import React from 'react'
import { Navigate } from 'react-router-dom'
import { useAtom } from 'jotai'
import { userAtom } from '../stores/userAtom'
import { isAuthorized } from '../utils/auth.utils'
/**
 * PublicRoute component is responsible for rendering public routes.
 * It checks if the user is authenticated and authorized. If the user is authenticated
 * and authorized, it redirects them to the home page. Otherwise, it renders the children components.
 *
 * @param {React.ReactElement} children - The component to render if the user is not authenticated.
 * @returns {React.ReactElement} - The rendered component or a redirect to the home page.
 */

interface PublicRouteProps {
  children: React.ReactElement
}

const PublicRoute: React.FC<PublicRouteProps> = ({ children }) => {
  const [user] = useAtom(userAtom)

  if (user && user?.role && isAuthorized(user.role)) {
    return <Navigate to={'/'} />
  }

  return children
}

export default PublicRoute
